/**
  * @desc Load google maps
  * html example: <div id="map-canvas" data-lat="56.109574" data-lng="10.155361" data-zoom="15"></div>
  * js example: if(document.getElementById('map-canvas').length){ loadScript(); }
  * @author Danni Larsen - DLA, Martin Haun - MHA
  * @requires: It also requires something to get the LAT, LNG and ZOOMLEVEL, and append it to the map-canvas element, as data-attibutes (umbraco 7: https://our.umbraco.org/projects/backoffice-extensions/angulargooglemaps) - remember to set a height for the map-canvas element!
*/


// Async load the GMaps API
var novicell = novicell || {};

novicell.map = new function () {
    var isLoaded = false;

    this.init = function () {
        document.onscroll = function () {
            if (!isLoaded && isScrolledIntoView(document.getElementById('js-site-footer-map'))) {
                isLoaded = true;
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBmL2NKoyJPNSV8yllyapSCXgPcH-mXoio&v=3.exp&callback=initialize';
                document.body.appendChild(script);
            }
        }
    }
}


var initialize = function () {
    // Get map element from HTML
    var mapElement = document.getElementById('js-site-footer-map');

    // Get city
    var city = mapElement.dataset.mapCity;

    // Set cordinates of the map
    var coordinates = new google.maps.LatLng(56.0337687, 10.2457146);

    // Set map options
    var mapOptions = {
        zoom: 10,
        disableDefaultUI: false,
        draggable: false,
        scrollwheel: false,
        center: coordinates,
        streetViewControl: false,
        mapTypeControl: false
    };

    // Set the google maps element
    var map = new google.maps.Map(mapElement, mapOptions);

    // Setup KML
    var kmlParser = new geoXML3.parser({ map: map, suppressInfoWindows: true });
    kmlParser.parse('/KmlFiles/' + city.toLowerCase() + '.kml');

    // Recalculate center on resize
    google.maps.event.addDomListener(window, "resize", function () {
        var center = map.getCenter();
        google.maps.event.trigger(map, "resize");
        map.setCenter(center);
    });
}

function getBoundsZoomLevel(bounds, mapElementWidth, mapElementHeight) {
    var WORLD_DIM = { height: 256, width: 256 };
    var ZOOM_MAX = 21;

    function latRad(lat) {
        var sin = Math.sin(lat * Math.PI / 180);
        var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    }

    function zoom(mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
    }

    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();

    var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

    var lngDiff = ne.lng() - sw.lng();
    var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

    var latZoom = zoom(mapElementHeight, WORLD_DIM.height, latFraction);
    var lngZoom = zoom(mapElementWidth, WORLD_DIM.width, lngFraction);

    return Math.min(latZoom, lngZoom, ZOOM_MAX);
}

// Loads element as soon as it hit the viewport
function isScrolledIntoView(el) {
    var elemTop = el.getBoundingClientRect().top;
    var elemBottom = el.getBoundingClientRect().bottom;

    return (elemBottom >= 0) && (elemTop <= window.innerHeight);
}